export default __webpack_public_path__ + "static/media/chivacan.091dc749.png";